import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import './Layout.css';
import { MaquetesThemeProvider, useMaquetesTheme } from '../context/MaquetesThemeContext';
import '../pages/MaquetesObba.css';
import '../pages/RelatoriosThemes.css';
import '../pages/OrcamentosTheme.css';
import '../pages/AdminTheme.css';
import '../pages/ModulesTheme.css';
import '../pages/LiquidLists.css';
import '../pages/FinanceTheme.css';
import '../pages/ObrasTheme.css';
import '../pages/SistemaIntegradoTheme.css';
import '../pages/LiquidHeaders.css';
import '../pages/LiquidConsistency.css';
import { OrcamentoFeedbackProvider } from './OrcamentoUI';

import { useAuth } from '../context/AuthContext';
import { useEffect } from 'react';

const isMobileDevice = () => {
    const ua = navigator.userAgent || navigator.vendor || '';
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua) || window.innerWidth <= 768;
};

const LayoutContent = ({ children }) => {
    const { active, theme } = useMaquetesTheme();
    const { pathname } = useLocation();
    const moduleTheme = /^(?:gestao-financeira|obras|trabalhadores|recursos-humanos|equipamentos|veiculos|despesas|revolut|reconciliacao|sistema-integrado)$/.test(pathname.split('/')[1]);
    const { user } = useAuth();

    useEffect(() => {
        if (user?.perfil_mobile || isMobileDevice()) {
            document.body.classList.add('mobile-profile');
        } else {
            document.body.classList.remove('mobile-profile');
        }
        return () => {
            document.body.classList.remove('mobile-profile');
        };
    }, [user]);

    return (
        <div className="app-layout" data-maquetes-theme={active ? theme : undefined}>
            <Sidebar />
            <main className="main-content" data-liquid-module={moduleTheme && active && theme === 'liquido' ? pathname.split('/')[1] : undefined}>
                {moduleTheme ? <OrcamentoFeedbackProvider>{children || <Outlet />}</OrcamentoFeedbackProvider> : children || <Outlet />}
            </main>
        </div>
    );
};

const Layout = ({ children }) => <MaquetesThemeProvider><LayoutContent>{children}</LayoutContent></MaquetesThemeProvider>;
export default Layout;
